export default function(instance) {
    return {
        getIndicationTariffs() {
            return instance.get('/api/indications/prices/');
		},
		
		getPassesTarifs() {
			return instance.get('/api/passes/prices/');
        },
        updatePricePasses(idPrice, data) {
            return instance.post(`/api/passes/prices/${idPrice}/`, {
                "kind": data.kind,
                "price": data.price
            })
        },
		updatePriceIndication(idPrice, data) {
            return instance.post(`/api/indications/prices/${idPrice}/`, {
                "kind": data.kind,
                "price": data.price
            })
        }
    }
}